// extracted by mini-css-extract-plugin
export default {"meals":"AvailableMeals_meals__QVTxI","meals-appear":"AvailableMeals_meals-appear__+6ldl"};